import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgLoggia = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="loggia_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>
				{
					`.prestation_cls_fill_none{fill:none;stroke:${color};stroke-miterlimit:40;stroke-width:10px}`
				}
			</style>
		</defs>
		<circle className="prestation_cls_fill_none" cx={255.12} cy={148.82} r={21.26} />
		<path
			className="prestation_cls_fill_none"
			d="m212.6 170.08-31.43 63.78M223.23 201.97l31.89 31.89h21.26l-21.26-42.52M85.04 233.86h170.08M106.3 361.42c0-11.74 9.52-21.26 21.26-21.26M127.56 340.16H318.9"
		/>
		<path
			className="prestation_cls_fill_none"
			d="M297.64 233.86h42.52V63.78H85.04V318.9h255.12v-63.78M212.6 85.04v63.78"
		/>
		<path className="prestation_cls_fill_none" d="M127.56 233.86V85.04h170.08V212.6" />
	</svg>
)
export default SvgLoggia
